/**
 * @file automatically generated from MApp.Spatial.NodeType
 */

export enum NodeType {
    ProjCrs = 0,
    BaseGeodCrs = 1,
    Datum = 2,
    Ellipsoid = 3,
    LengthUnit = 4,
    Conversion = 5,
    Method = 6,
    Id = 7,
    Parameter = 8,
    AngleUnit = 9,
    ScaleUnit = 10,
    CS = 11,
    Axis = 12,
    Order = 13,
    PrimeM = 14,
    Meridian = 15,
    GeodCrs = 16,
    VertCrs = 17,
    VDatum = 18,
    CompoundCrs = 19,
    EngCrs = 20,
    EDatum = 21,
    BaseProjCrs = 22,
    DerivingConversion = 23,
    CoordinateOperation = 24,
    SourceCrs = 25,
    TargetCrs = 26,
    ParameterFile = 27,
    TimeUnit = 28,
    Scope = 29,
    Area = 30,
    Bbox = 31,
    Uri = 32,
    Remark = 33,
    Citation = 34
}
